import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "../../components/Navbar";
import Formaciones from "../../components/carrusel/UserFormacionDestacada";
import "./css/Empleo.css";

const Formacion = () => {

  const navigate = useNavigate();
  const [categoria, setCategoria] = useState("destacadas");
  
  return (
    <>
        <Navbar />
        
         <main className="main-user empleo-formacion">
            <section className="between cabecera">
              <h1 className="titulo-user align-center">
                <span className="titulo-user mayusculas align-center gap-10">
                  Cursos  
                  <select
                    aria-label="Filtrados por"
                    className="desplegable-empleo mayusculas" 
                    value={categoria} 
                    onChange={(e) => setCategoria(e.target.value)}
                  >
                    <option value="destacadas">Destacados</option>
                    <option value="presencial">presenciales</option>
                    <option value="online">online</option>
                    <option value="semipresencial">semipresenciales</option>
                    <option value="todos">TODoS</option>
                  </select>
                </span>
              </h1>
              <button className="boton-modal boton rosa" onClick={() => navigate("/recursos", { state: { categoria: "formacion" } })}>Recursos</button>
            </section>
            
            <Formaciones categoria={categoria} />

        </main>
    </>
  );
};

export default Formacion;